import axios from "axios";

const HOST_API = process.env.REACT_APP_URL;

export const getOrdenesTrabajo = (barrioId, administracionId) =>
  axios.get(`${HOST_API}api/ordenTrabajo/getOrdenesTrabajo`, {
    params: { barrioId, administracionId },
  });

export const addOrdenTrabajo = (payload) =>
  axios.post(`${HOST_API}api/ordenTrabajo/addOrdenTrabajo`, payload);

export const cambiarEstadoOrdenTrabajo = (payload) =>
  axios.post(`${HOST_API}api/ordenTrabajo/cambiarEstado`, payload);

export const getOrdenTrabajoHistorial = (ordenTrabajoId) =>
  axios.get(`${HOST_API}api/ordenTrabajo/getHistorial`, {
    params: { ordenTrabajoId },
  });

export const getOrdenTrabajoItems = (ordenTrabajoId) =>
  axios.get(`${HOST_API}api/ordenTrabajo/getItems`, {
    params: { ordenTrabajoId },
  });

export const addOrdenTrabajoItem = (ordenTrabajoId, descripcion, orden) =>
  axios.post(`${HOST_API}api/ordenTrabajo/addItem`, { ordenTrabajoId, descripcion, orden });

export const toggleOrdenTrabajoItem = (ordenTrabajoItemId, hecho) =>
  axios.post(`${HOST_API}api/ordenTrabajo/toggleItem`, { ordenTrabajoItemId, hecho });

export const deleteOrdenTrabajoItem = (ordenTrabajoItemId) =>
  axios.delete(`${HOST_API}api/ordenTrabajo/deleteItem`, {
    params: { ordenTrabajoItemId },
  });

export const getOrdenTrabajoDocumentos = (ordenTrabajoId) =>
  axios.get(`${HOST_API}api/ordenTrabajo/getDocumentos`, {
    params: { ordenTrabajoId },
  });

export const addOrdenTrabajoDocumento = (ordenTrabajoId, administracionId, barrioId, usuarioId, file) => {
  const formData = new FormData();
  formData.append("model", JSON.stringify({ ordenTrabajoId, administracionId, barrioId, usuarioId }));
  formData.append("file", file);
  return axios.post(`${HOST_API}api/ordenTrabajo/addDocumento`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const deleteOrdenTrabajoDocumento = (ordenTrabajoDocumentoId) =>
  axios.delete(`${HOST_API}api/ordenTrabajo/deleteDocumento`, {
    params: { ordenTrabajoDocumentoId },
  });

export const deleteOrdenTrabajo = (ordenTrabajoId, administracionId) =>
  axios.delete(`${HOST_API}api/ordenTrabajo/deleteOrdenTrabajo`, {
    params: { ordenTrabajoId, administracionId },
  });
